import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
    retrieve_inventory_list: { status: "idle" },
};

export const retrieve_inventory_list_Slice = createSlice({
    name: "retrieve_inventory_list",
    initialState,
    reducers: {
        success_retrieve_inventory_list: (state, action) => {
            state.retrieve_inventory_list = { status: app_consts.SUCCESS, data: action.payload };
        },
        fail_retrieve_inventory_list: (state, action) => {
            state.retrieve_inventory_list = { status: app_consts.FAIL, message: action.payload };
        },
        reset_retrieve_inventory_list: (state) => {
            state.retrieve_inventory_list = { status: app_consts.IDLE };
        },
        loading_retrieve_inventory_list: (state) => {
            state.retrieve_inventory_list = { status: app_consts.LOADING };
        },
    }
});

export const { success_retrieve_inventory_list, fail_retrieve_inventory_list, reset_retrieve_inventory_list, loading_retrieve_inventory_list } = retrieve_inventory_list_Slice.actions;

export default retrieve_inventory_list_Slice.reducer;